import { FormControlLabel, Radio, RadioGroup, TableCell, TableRow } from '@mui/material'
import { snakeCase } from 'lodash'

import { SelectionRowProps } from 'common/interfaces'
import { selectionRowStyle } from 'common/styles'

export default function RadioGroupRows({
  item,
  variants,
  value,
  handleChange,
}: SelectionRowProps): JSX.Element {
  const { groupWrap, controlLabel } = selectionRowStyle

  const radioGroupName = snakeCase(item)

  return (
    <TableRow>
      <TableCell>{item}</TableCell>
      <TableCell>
        <RadioGroup
          name={radioGroupName}
          value={value[radioGroupName]}
          onChange={handleChange}
          sx={groupWrap}
        >
          {variants.map((variant) => (
            <FormControlLabel
              value={variant}
              control={<Radio />}
              label=""
              key={item + variant}
              sx={controlLabel}
            />
          ))}
        </RadioGroup>
      </TableCell>
    </TableRow>
  )
}
